import {http} from "@/utils/http.js";

// 获取用户信息
export const getUserInfo = (data)=> http.request({ url: '/user/info', method: 'post', data});

// 获取企业信息
export const getCompanyInfoById = (data)=> http.request({ url: '/company/detail', method: 'post', data});

// 获取企业列表
export const getCompanyList = (data)=> http.request({ url: '/company/list', method: 'post', data});

// 切换企业
export const changeCompany = (data)=> http.request({ url: '/user/change_use_company_id', method: 'post',data});

// 获取数据总览
export const getDataInfo = (data)=> http.request({ url: '/statistics/overview', method: 'post',data});

// 获取app列表
export const getAppList = (data)=> http.request({ url: '/product/list', method: 'post',data});

// 获取资源概览
export const getResourceInfo = (data)=> http.request({ url: '/statistics/resourceOverview', method: 'post',data});

// 获取公告列表
export const getNotifyList = (data)=> http.request({ url: '/index/notifyList', method: 'post', data});